import { render, staticRenderFns } from "./Underline.vue?vue&type=template&id=06f2f6dc&"
import script from "./Underline.vue?vue&type=script&lang=js&"
export * from "./Underline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports